(() => {
  const FIGURES = ['Baddie', 'Dobby', 'Shelly', 'Ray', 'Beanie', 'Highnrich', 'Nala', 'Lilli', 'Marley', 'Junior', 'DJ', 'Coco'];
  const PANEL_ID = 'shellax-set-selector';

  function getSetCount() {
    const text = `${location.pathname} ${document.title} ${(document.querySelector('h1') || {}).textContent || ''}`.toLowerCase();
    if (!location.pathname.toLowerCase().includes('/products/')) return 0;
    if (text.includes('6er-set') || text.includes('6er set') || text.includes('6er')) return 6;
    if (text.includes('3er-set') || text.includes('3er set') || text.includes('3er')) return 3;
    if (text.includes('2er-set') || text.includes('2er set') || text.includes('2er')) return 2;
    return 0;
  }

  function findForm() {
    return document.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('product-form-component form') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="cart/add"]');
  }

  function buildPanel(count) {
    const panel = document.createElement('div');
    panel.id = PANEL_ID;
    panel.className = 'shellax-set-selector';
    panel.innerHTML = `
      <style>
        .shellax-set-selector{margin:18px 0 20px;padding:18px;border:1px solid rgba(34,60,22,.16);border-radius:22px;background:rgba(255,255,255,.58);box-shadow:0 12px 30px rgba(34,60,22,.07)}
        .shellax-set-selector__title{margin:0 0 6px;color:#223C16;font-size:1.05rem;line-height:1.3;font-weight:900}
        .shellax-set-selector__hint{margin:0 0 14px;color:rgba(34,60,22,.72);font-size:.94rem;line-height:1.5}
        .shellax-set-selector__grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px}
        .shellax-set-selector label{display:grid;gap:6px;color:#223C16;font-size:.9rem;font-weight:850}
        .shellax-set-selector select{width:100%;min-height:46px;border:1px solid rgba(34,60,22,.24);border-radius:14px;background:#F8ECD9;color:#223C16;padding:0 12px;font:inherit;font-weight:750;outline:none}
        .shellax-set-selector select:focus{border-color:#223C16;box-shadow:0 0 0 3px rgba(34,60,22,.12)}
        .shellax-set-selector__error{display:none;margin:12px 0 0;color:#7a2d17;font-size:.9rem;font-weight:850}
        .shellax-set-selector.is-invalid .shellax-set-selector__error{display:block}
        @media(max-width:749px){.shellax-set-selector{padding:15px;border-radius:18px}.shellax-set-selector__grid{grid-template-columns:1fr}}
      </style>
      <p class="shellax-set-selector__title">Wähle deine ${count} Figuren</p>
      <p class="shellax-set-selector__hint">Bitte wähle alle Figuren aus, bevor du das Set in den Warenkorb legst.</p>
      <div class="shellax-set-selector__grid"></div>
      <input type="hidden" name="properties[Set-Auswahl]" value="" data-shellax-summary>
      <p class="shellax-set-selector__error">Bitte erst alle Figuren für dein Set auswählen.</p>
    `;

    const grid = panel.querySelector('.shellax-set-selector__grid');
    for (let i = 1; i <= count; i += 1) {
      const label = document.createElement('label');
      const span = document.createElement('span');
      span.textContent = `Figur ${i}`;
      const select = document.createElement('select');
      select.name = `properties[Figur ${i}]`;
      select.required = true;
      select.setAttribute('data-shellax-select', 'true');
      select.innerHTML = '<option value="">Bitte auswählen</option>' + FIGURES.map((name) => `<option value="${name}">${name}</option>`).join('');
      label.appendChild(span);
      label.appendChild(select);
      grid.appendChild(label);
    }
    return panel;
  }

  function values(panel) {
    return Array.from(panel.querySelectorAll('[data-shellax-select]')).map((select) => select.value.trim());
  }

  function isValid(panel) {
    const list = values(panel);
    const valid = list.every(Boolean);
    const summary = panel.querySelector('[data-shellax-summary]');
    if (summary) summary.value = valid ? list.join(', ') : '';
    return valid;
  }

  function findButtons(form) {
    const scope = form.closest('product-form-component') || form;
    return Array.from(scope.querySelectorAll('button[type="submit"], button[name="add"], .add-to-cart-button'));
  }

  function updateButtons(form, panel) {
    const valid = isValid(panel);
    findButtons(form).forEach((button) => {
      if (!button.dataset.shellaxManaged) button.dataset.shellaxManaged = 'true';
      button.disabled = !valid;
      button.setAttribute('aria-disabled', String(!valid));
      button.style.opacity = valid ? '' : '.55';
      button.style.cursor = valid ? '' : 'not-allowed';
    });
    const payment = (form.closest('product-form-component') || form).querySelector('.shopify-payment-button');
    if (payment) {
      payment.style.opacity = valid ? '' : '.35';
      payment.style.pointerEvents = valid ? '' : 'none';
    }
  }

  function init() {
    const count = getSetCount();
    if (!count) return;
    if (document.getElementById(PANEL_ID)) return;
    const form = findForm();
    if (!form) return;

    const panel = buildPanel(count);
    const target = form.querySelector('.product-form-buttons') || form.querySelector('button[type="submit"], button[name="add"]');
    if (target) target.parentNode.insertBefore(panel, target);
    else form.appendChild(panel);

    updateButtons(form, panel);
    panel.addEventListener('change', () => {
      panel.classList.remove('is-invalid');
      updateButtons(form, panel);
    });

    form.addEventListener('submit', (event) => {
      if (!isValid(panel)) {
        event.preventDefault();
        event.stopPropagation();
        panel.classList.add('is-invalid');
        panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  setTimeout(init, 300);
  setTimeout(init, 900);
})();
